import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ClientTenant } from 'src/app/common/viewmodel/tenant-model';
import { TenantService } from 'src/app/shared/services/tenant/tenant.service';
import { TenantValidator } from 'src/app/shared/validators/tenant.validator';

@Component({
  selector: 'app-create-tenant-modal',
  templateUrl: './create-tenant-modal.component.html',
  styleUrls: ['./create-tenant-modal.component.scss']
})
export class CreateTenantModalComponent{

  tenantForm: FormGroup;
  Name: FormControl;  
  loading: boolean;
  createTenantError: boolean;
  msg: string;
  isCreating: boolean = false;
  
  tenants: any = [];

  constructor(public tenantService: TenantService, private fb: FormBuilder, private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(){
    this.initializeForm();
    this.listTenants();
  }
  initializeForm() {
    this.tenantForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(150), Validators.pattern('[a-zA-Z0-9 \'\-]+'), TenantValidator.noWhitespaceValidator]],
      })
  }
  listTenants(){
    this.tenantService.listTenants().subscribe(t => {
      this.tenants = t;
    })
  }
  onCloseModal() {
    this.activeModal.close();
  }
  createTenant() {
    this.loading = true;
 
    var tenant = new ClientTenant();
    tenant.Name = this.tenantForm.controls.name.value;
    tenant.CreatedBy = 'user';
 
    this.tenantService.createTenant(tenant).subscribe(() => {
      this.router.navigate(['/home']);
      this.activeModal.close(true);
      //  (message: any) => {
      //   this.refresh();
      //   //  if(message == 'NameExist'){
      //   //    let nameControl = this.tenantForm.controls.name;         
             
      //   //    nameControl.setErrors({ 'tenantnameexists': true });              
           
      //   //    this.loading = false;          
      //   //  }
      //   //  else{
      //   //   this.refresh();
      //   //  }       
      //  }, (error: any) => {
      //    this.createTenantError = true;
      //    this.msg = error.error.text;
       });     
   }
   onTenantNameChange() {
    let nameControl = this.tenantForm.controls.name;

    let error = TenantValidator.tenantNameExists(nameControl, this.tenants);

    if(error) {
      nameControl.setErrors(error);
    } else {
      nameControl.errors;
    }
  }
   refresh(){
    this.router.navigate(['/home']);
    this.activeModal.close(true);
  }   
}
